<!--Donation Amounts: 250, 500, 1000-->
<!--Honorree language, saaog-->
<!--Add link to pdf form to page at the bottom-->
<!--Honoree Message, for the honoree: Optional-->
<template>
    <div id="app">
        <transition name="component-fade" mode="in-out">
            <div v-if="state.loading" class="container text-center" style="margin-top: 50px">
                <pulse-loader></pulse-loader>
            </div>

            <div v-else class="container">
                <Header></Header>
                <div v-if="!state.response.transactionStatus" class="row">
                    <div class="col-sm">
                        <RegSelect></RegSelect>
                        <RegistrantInfo v-show="state.showSection.register"></RegistrantInfo>
                        <Trainees v-show="state.showSection.trainee"></Trainees>
                        <OneDay v-show="state.showSection.oneDay"></OneDay>
                        <MedicalInfo v-show="state.showSection.medical"></MedicalInfo>
                        <StaffBundle v-show="state.showSection.staffBundle"></StaffBundle>
                        <Industry v-show="state.showSection.industry"></Industry>
                    </div>
                    <div class="col col-sm-4">
                        <Order></Order>
                        <transition name="component-fade" mode="out-in">
                            <div v-if="showCheckout">

                                <div v-if="state.registrantData.total > 0">
                                    <Promo/>
                                </div>
                                <Terms></Terms>
                                <br>
                                <Payment/>
                            </div>
                        </transition>
                    </div>
                </div>
                <div v-else class="row">
                    <div class="col">
                        <Confirmation/>
                    </div>
                    <div class="col col-sm-4">
                        <Order></Order>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex'
    import Header from './components/Header'
    import RegSelect from './components/RegSelect'
    import Order from './components/Order'
    import RegistrantInfo from './components/RegistrantInfo'
    import MedicalInfo from './components/MedicalInfo'
    import Promo from './components/Promo'
    import Payment from './components/Payment'
    import Confirmation from './components/Confirmation'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import Terms from './components/Terms'
    import Trainees from './components/Trainees'
    import OneDay from './components/OneDay'
    import StaffBundle from './components/StaffBundle'
    import Industry from './components/Industry'

    export default {
        name: 'app',
        data: function () {
            return {
                formstate: {},
            }
        },
        computed: {
            ...mapGetters({
                state: 'getState',
            }),
            showCheckout: function () {
                if (this.state.registrantData.regType.id) {
                    return true
                }
            },
            formComplete: function () {
                let requiredSections = this.state.meetingData.reg_type.filter((regType) => {
                    if (this.state.registrantData.regType == regType.id) {
                        return regType
                    }
                });
                let fieldGroupsRequired = requiredSections[0].extraFieldGroupsRequired

                let found = fieldGroupsRequired.filter((group) => {

                    if (this.state.formstate[group].$valid) {

                        return this.state.formstate[group]

                    }
                });

                console.log(fieldGroupsRequired);

                if (found == fieldGroupsRequired) {
                    return true
                }

            }
        },
        created() {
            this.$store.dispatch('setInitialState');

        },
        methods: {
            fieldClassName: function (field) {

                if (!field) {
                    return ''
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success'
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger'
                }
            },
            editRegistration: function () {

            },
        },
        components: {
            Header,
            RegSelect,
            Order,
            PulseLoader,
            RegistrantInfo,
            MedicalInfo,
            Promo,
            Payment,
            Confirmation,
            Terms,
            Trainees,
            OneDay,
            StaffBundle,
            Industry
        },
    }

</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    .meeting-header {
        text-align: left;
    }

    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .7s ease;
    }

    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }


</style>
